// ----------------------------------------------------------------------
// <copyright file="Izenda.DashboardPartFilterField.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function() {
  var m = require('mobx');
  var trackable = require('share/tracking/Izenda.Trackable');
  var ObjectStateConstants = require('logic/data/Izenda.ObjectStateConstants');
  const { omit } = require('lodash/fp');

  function DashboardPartFilterField(data) {
    var props = {
      filterFieldId: null,
      value: null,
      operatorId: null,
      isCommon: true,
      filterField: null,
      configField: null,
      operatorSetting: null,
      displayName: null,
      state: null,
      id: null,
      version: null
    };

    m.extendObservable(trackable(this), props);

    data && this.populateData(data);
  }

  /**
   * Populate information.
   * @param  {Object} data
   */
  DashboardPartFilterField.prototype.populateData = m.action(function(data) {
    this.filterFieldId = data.filterFieldId;
    this.value = data.value;
    this.operatorId = data.operatorId;
    this.isCommon = data.isCommon;
    this.filterField = data.filterField;
    this.displayName = data.displayName;
    this.state = data.state;
    this.id = data.id;
    this.version = data.version;

    this.resetDirty();
  });

  /**
   * Set operator id.
   * @param  {String} id
   */
  DashboardPartFilterField.prototype.setOperatorId = m.action(function(id) {
    this.operatorId = id;
    this.filterField.operatorId = id;

    this.markDirty();
  });

  /**
   * set filter value
   * @method setFilterValue
   * @param  {[type]}       filterValue [description]
   */
  DashboardPartFilterField.prototype.setFilterValue = m.action(function(filterValue) {
    this.value = filterValue;
    this.filterField.value = filterValue;
    this.state === ObjectStateConstants.NONE && (this.state = ObjectStateConstants.UPDATE);

    this.markDirty();
  });

  /**
   * set operatorSetting
   * @method setOperatorSetting
   * @param  {[type]}           operatorSetting [description]
   */
  DashboardPartFilterField.prototype.setOperatorSetting = function(operatorSetting) {
    this.operatorSetting = operatorSetting;

    this.markDirty();
  };

  /**
   * Update state.
   * @param {Number} value
   */
  DashboardPartFilterField.prototype.updateState = function(value) {
    this.state = value;

    this.markDirty();
  };

  /**
   * build data for save
   * @method buildDataForSaving
   * @return {[type]}           [description]
   */
  DashboardPartFilterField.prototype.buildDataForSaving = function() {
    return m.toJS(omit(['configField'], this));
  };

  module.exports = DashboardPartFilterField;
})();



// WEBPACK FOOTER //
// ./ui/logic/models/Dashboard/Izenda.DashboardPartFilterField.js